import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { isWhiteColor, removeDefaultParams } from '../../../Utils/helper';
import {
  cardServedEvent,
  clickCardEvent,
  fireClickedCta,
} from '../../../Utils/StoreHomePageUtils';
import { AddToCartButtonFilled } from '../../StoreCategoryPage/SubCategoryProducts/styled';
import BannersGridImage from './BannersGridImage';
import {
  BannerSubTitle,
  BannerTitle,
  GridBanner,
  GridBoxContent,
  GridBoxTitle,
  GridWrapper,
} from './styled';

export default function BannersGrid(props) {
  const {
    banner,
    type,
    parentIndex,
    newDiaperVersion,
    happiness,
    isForNewCdPage,
    showNewGridView,
    handleScroll,
    addProductToCart,
  } = props;

  const router = useRouter();
  useEffect(() => {
    cardServedEvent(banner);
  }, []);
  const onBannerClick = (index, value, element) => {
    const sectionDetails = {
      heading: banner?.heading || banner?.itemName,
      itemId: banner?._id,
      position: parentIndex,
    };

    clickCardEvent(element, sectionDetails);
    if (element?.sectionId && handleScroll) {
      handleScroll(element?.sectionId);
      return;
    }

    if (element?.addToCartProductId && addProductToCart) {
      addProductToCart(element?.addToCartProductId);
      return;
    }
    router.push(value + window?.location?.search);
  };

  return (
    <GridWrapper
      happiness={happiness}
      sectionBgColorEnd={banner?.sectionBgColorEnd}
      sectionBgColorStart={banner?.sectionBgColorStart}
      padding={
        !isWhiteColor(banner?.sectionBgColorStart, banner?.sectionBgColorEnd)
      }
      isForNewCdPage={isForNewCdPage}
      showNewGridView={showNewGridView}
    >
      {banner?.sectionBgImage ? (
        <img
          alt=""
          src={banner?.sectionBgImage}
          width="100%"
          height="100%"
          style={{
            objectFit: 'contain',
            marginTop: '40px',
            marginBottom: '10px',
          }}
        />
      ) : null}
      {banner?.heading && type != 'bestSeller' ? (
        <BannerTitle subHeading={banner?.subHeading?.length}>
          <h2>{banner?.heading.toLowerCase()} </h2>
        </BannerTitle>
      ) : null}
      {banner?.subHeading && type != 'bestSeller' ? (
        <BannerSubTitle>
          <h2>{banner?.subHeading} </h2>
        </BannerSubTitle>
      ) : null}
      <GridBanner
        gridSize={banner?.items?.length}
        mobileThreeGrid={banner.headingAlignment}
        newDiaperVersion={newDiaperVersion}
        showNewGridView={showNewGridView}
      >
        {banner?.items?.map((element, index) => {
          return (
            <div className="column_direction" key={index}>
              <BannersGridImage
                parentIndex={parentIndex}
                element={element}
                sectionHeading={banner?.heading}
                onBannerClick={onBannerClick}
                banner={banner}
              />
              {element?.heading && (
                <GridBoxTitle>{element.heading}</GridBoxTitle>
              )}
              {element?.subHeading && (
                <GridBoxContent>{element.subHeading}</GridBoxContent>
              )}
              {element?.showCta ? (
                <Link
                  href={{
                    pathname: element?.deeplinkValue,
                    query: removeDefaultParams(router.query),
                  }}
                  passHref
                  locale={false}
                  legacyBehavior
                >
                  <AddToCartButtonFilled
                    listTemplate
                    as="a"
                    className="add_btn_filled"
                    onClick={() => fireClickedCta(element, banner)}
                  >
                    {element.ctaText}
                  </AddToCartButtonFilled>
                </Link>
              ) : null}
            </div>
          );
        })}
      </GridBanner>
    </GridWrapper>
  );
}
